import { defineMessages } from '@atlassian/jira-intl';
import type { KnowledgeCommonFlagMessage } from '@atlassian/jira-servicedesk-knowledge-common/src/common/types.tsx';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default defineMessages({
	draftSuccessFlagTitle: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-title',
		defaultMessage: 'Article published',
		description:
			'Title message to be shown to the user when the draft has been successfully published',
	},

	draftSuccessFlagDescription: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.draft-success-flag-description',
		defaultMessage:
			'This article has been added to your knowledge base. Your articles list will update soon.',
		description:
			'Title message to be shown to the user when the draft has been successfully published',
	},

	draftSuccessSavedFlagTitle: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-title',
		defaultMessage: 'Draft saved',
		description:
			'Title message of the flag to be shown to the user when the draft has been successfully saved but not published',
	},

	draftSuccessSavedFlagDescription: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.draft-success-saved-flag-description',
		defaultMessage: 'Find it in Drafts in your knowledge base.',
		description:
			'Description message of the flag to be shown to the user when the draft has been successfully saved but not published',
	},

	articleSuccessSavedFlagTitle: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-title',
		defaultMessage: 'We’ve saved your unpublished changes',
		description:
			'Title message of the flag to be shown to the user when the draft has been successfully saved but not published',
	},

	articleSuccessSavedFlagDescription: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.article-success-saved-flag-description',
		defaultMessage: 'You can edit the article and publish these changes later.',
		description:
			'Description message of the flag to be shown to the user when the draft has been successfully saved but not published',
	},

	confluenceCreatePageFailureTitle: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-title',
		defaultMessage: "We're having trouble creating the article",
		description:
			'Title message of the flag to be shown to the user when the embed editor experience fails to load',
	},

	confluenceCreatePageFailureDescription: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.confluence-create-page-failure-description',
		defaultMessage: 'Wait for a few minutes and try creating the article again.',
		description:
			'Description message of the flag to be shown to the user when the embed editor experience fails to load',
	},

	articleDeletedFlagTitle: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-title',
		defaultMessage: 'Article deleted',
		description:
			'Title message of the flag to be shown to the user when the article has been successfully deleted ',
	},

	articleDeletedFlagDescription: {
		id: 'servicedesk.knowledge-hub.common.draft-article-flags.article-deleted-flag-description',
		defaultMessage:
			'This article has been deleted from your knowledge base. Your articles list will update soon.',
		description:
			'Description message of the flag to be shown to the user when the article has been successfully deleted',
	},
}) as KnowledgeCommonFlagMessage;
